import {
    knowledgeBuilderService
} from 'shared/api';

// Using Knowledge Builder proxy service for centralized API calls
/**
 * Service class for performing RAG operations.
 */
class MilvusService {

    /**
     * Query embeddings from a collection via proxy.
     * @param {Object} body - The body of the request.
     * @returns {Promise<Object>}
     */
    async hybridSearch(body) {
        const res = await knowledgeBuilderService.performRequestWithFullResponse('v2/kb/api/v1/search/', {
            method: 'POST',
            data: body
        });
        return res;
    }
}

const milvusService = new MilvusService();
export { milvusService };
